import { render, staticRenderFns } from "./PlaylistPitchMeetingShow.vue?vue&type=template&id=b80bc268"
import script from "./PlaylistPitchMeetingShow.vue?vue&type=script&lang=js"
export * from "./PlaylistPitchMeetingShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports